<template>
  <section class="wt-background-shield">
    <welcome-background-shield icon="welcome-background-shield" />
  </section>
</template>

<script>
export default {
  name: 'WelcomeBackgroundShield',
  components: {
    WelcomeBackgroundShield: () => import(/* webpackChunkName: "main"*/ '@/components/svg/WelcomeBackgroundShield.vue'),
  },
};
</script>

<style lang="postcss">
.wt-background-shield {
  @apply container mx-auto relative;
  z-index: -1;

  svg {
    @apply absolute top-64;
    width: 80%;
    height: 55vh;
    left: 50%;
    transform: translateX(-50%);

    @screen sm {
      width: 80%;
      height: 80vh;
    }

    @screen xl {
      width: 80%;
      height: 70vh;
    }
  }
}
</style>
